import { render, staticRenderFns } from "./scope-of-activitie.component.vue?vue&type=template&id=1c7241f0&"
import script from "./scope-of-activitie.component.ts?vue&type=script&lang=ts&"
export * from "./scope-of-activitie.component.ts?vue&type=script&lang=ts&"
import style0 from "./scope-of-activitie.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports